const fetchAreas = {
  text: 'Ningún resultado encontrado'
}

export default fetchAreas;
